<section class="related-transactions">
    <h3 class="section-heading">Related Transactions</h3>
    @if (relatedTransactions.length === 0) {
        <p class="empty-message">No related transactions</p>
    } @else {
        <div class="table-container">
            <table class="data-table">
                <thead>
                    <tr>
                        <th class="table-header">Transaction ID</th>
                        <th class="table-header">Transaction Date</th>
                        <th class="table-header">Amount</th>
                        <th class="table-header">Status</th>
                        <th class="table-header">Relationship</th>
                    </tr>
                </thead>
                <tbody>
                    @for (txn of relatedTransactions; track txn.transactionId) {
                        <tr class="table-row">
                            <td class="table-cell">
                                <button class="transaction-link" (click)="transactionSelected.emit(txn.transactionId)" [attr.aria-label]="'View transaction ' + txn.transactionId">
                                    {{ txn.transactionId }}
                                </button>
                            </td>
                            <td class="table-cell">{{ txn.transactionDate | date:'MM/dd/yyyy' }}</td>
                            <td class="table-cell">{{ txn.amount | negativeCurrency }}</td>
                            <td class="table-cell">
                                <ach-status-badge [status]="txn.status" />
                            </td>
                            <td class="table-cell">{{ txn.relationship }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</section>
